import { Input } from "../../input/input";

import { QuestionWithHeaderAndFooter } from "../question";

import { QuestionContent } from "../question-content";
import { NumberQuestionProps } from "../types";

export const NumberQuestion = (props: NumberQuestionProps) => {
  const {
    gap,
    required,
    invalid,
    labelClassName,
    className,
    layoutProps,
    questionId,
    questionLabel,
    accessibilityTextOfRequired,
    questionLabelProps,
    answer,
    placeholder,
    size,
    disabled,
    changeEventHandler,
    answerProps,
    contentClassName,
    answerAriaLabel,
    footerStackSpacing,
    note,
    maxNote,
    maxLength,
    errorMessage,
    errorMessageProps,
    noteProps,
    answerDataTestId
  } = props;

  const headerFooterProps = {
    gap,
    required,
    invalid,
    labelClassName,
    questionId,
    className,
    layoutProps,
    questionLabel,
    accessibilityTextOfRequired,
    questionLabelProps,
    footerStackSpacing,
    answerLength: answer?.length,
    note,
    maxLength,
    maxNote,
    errorMessage,
    errorMessageProps,
    noteProps
  };

  return (
    <QuestionWithHeaderAndFooter {...headerFooterProps}>
      <QuestionContent>
        <Input
          id={questionId}
          aria-label={answerAriaLabel}
          className={contentClassName}
          type="text"
          value={answer}
          onChange={changeEventHandler}
          placeholder={placeholder}
          maxLength={maxLength}
          disabled={disabled}
          {...answerProps}
          size={size}
          data-testid={answerDataTestId}
        />
      </QuestionContent>
    </QuestionWithHeaderAndFooter>
  );
};
